import {useTransition} from '@logistics-frontend/blocks'
import {ServerError, useBaseErrorCatcher} from '@logistics-frontend/core/utils/network'
import {useCallback, useState} from 'react'
import {useParams} from 'react-router-dom'

import {fetchSendFeedback, UserFeedback} from 'src/api'

import {useSharedRouteInfo} from '../../hooks'
import {RouterParams} from '../../types'
import {toUserFeedback} from './toUserFeedback'

const FEEDBACK_KEY = 'route/feedback'

export const useSendFeedback = () => {
  const {sharingKey = ''} = useParams<RouterParams>()
  const info = useSharedRouteInfo()
  const [feedback, setFeedback] = useState<UserFeedback>(toUserFeedback(info) || {})
  const errorCatcher = useBaseErrorCatcher()

  const [, startTransition] = useTransition<unknown, ServerError>(undefined, {
    key: FEEDBACK_KEY,
  })

  const sendFeedbackHandler = useCallback(
    (update: UserFeedback) => {
      const updatedFeedback = {...feedback, ...update}

      // fetchSendFeedback не возвращает ни какого значения, мы оптимистично обновляем значение с updatedFeedback
      setFeedback(updatedFeedback)
      startTransition(() => fetchSendFeedback(updatedFeedback, sharingKey), {
        onError: error => {
          // При возникновении ошибки, откатываем оптимистичный апдейт фидбэка
          setFeedback(feedback)
          errorCatcher()
        },
      })
    },
    [feedback, sharingKey, errorCatcher],
  )

  return [feedback, sendFeedbackHandler] as const
}
